<template>
  <li class="scope">
    <div class="iconWrapper">
      <img v-svg-inline class="icon" :src="src" :alt="iconType" />
    </div>
    <div class="txtWrapper">
      <p v-html="$t(title)" class="title" />
      <p v-html="$t(description)" class="details" />
    </div>
  </li>
</template>

<script>
export default {
  props: {
    iconType: {
      type: String,
      default: "openid",
    },
  },
  data() {
    return {
      test: "../assets/imgs/icon_openid.svg",
    };
  },
  computed: {
    src() {
      return require("../assets/imgs/icon_" + this.iconType + ".svg");
    },
    title() {
      return "consent.scopes." + this.iconType + ".title";
    },
    description() {
      return "consent.scopes." + this.iconType + ".description";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
li.scope
  +flex(flex-start, center, row)
  padding: 12px 0
  border: solid 1px $gs2
  border-radius: 5px
  margin-bottom: 10px
  .iconWrapper
    +size(48px, auto)
    +flex()
    .icon
      +size(24px)
  .txtWrapper
    flex: 1
    +flex(center, flex-start)
    padding-right: 20px
    .title
      +ffw(bold)
      +fs(s)
      margin-bottom: 5px
    .details
      +fs(xs)
      +lh
</style>
